import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Optional,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { CommonService } from '../shareModule/services/common.service';
import { GoogleMapsService } from '../google-maps.service';
import { AuthServiceService } from '../shareModule/services/auth-service.service';
import { CustomerService } from '../shareModule/services/customer.service';
import {
  debounce,
  debounceTime,
  distinctUntilChanged,
  filter,
  firstValueFrom,
  fromEvent,
  interval,
  map,
  Observable,
  Subject,
  Subscription,
  take,
  takeUntil,
  tap,
  throttle,
  timer,
} from 'rxjs';
import {
  NgbActiveModal,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { LocalServiceService } from '../shareModule/services/local-service.service';
import { SharedService } from '../shareModule/services/shared.service';
import { environment } from 'src/environments/environment';
import { SignInComponent } from '../customers/layout/component-layout/sign-in/sign-in.component';
import { MarketplacePageComponent } from '../customers/marketplace/marketplace.component';
import { ActivatedRoute, Router } from '@angular/router';
import { RecommendationsFormComponent } from '../customers/community/recommandations-form/recommandations-form.component';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { UploadEditedImageComponent } from '../community/upload-edited-image/upload-edited-image.component';
import {
  EditedImageBatchResult,
  EditedImageResult,
} from '../community/upload-edited-image/upload-edited-image.types';
import { RoleService } from '../shareModule/services/roles/role.service';
import { EditCategoryComponent } from '../edit-category/edit-category.component';
import { EditBookingComponent } from '../edit-category/edit-booking/edit-booking.component';
import { ShowBookingsComponent } from './show-bookings/show-bookings.component';
import { EditBookingContentComponent } from './edit-booking-content/edit-booking-content.component';
import { Location } from '@angular/common';
import { AppState } from '../shareModule/states/app.state';
import { select, Store } from '@ngrx/store';
import { selectUser } from '../shareModule/states/user-details';
import { SeoService } from '../shareModule/services/seo.service';
import { ApiResponse } from '../shareModule/models/common.model';
import { MemberNotificationService } from '../shareModule/services/member-notification.service';
import { MenuOptionsComponent } from '../customers/layout/customers-layout/menu-options/menu-options.component';
import { MarketplaceProfileComponent } from '../customers/layout/component-layout/marketplace-profile/marketplace-profile.component';
import { error } from 'console';
import { DiscountData } from '../shareModule/states/nearby/nearby.state';
import { selectDiscountData } from '../shareModule/states/nearby';
import { StoryKachiingComponent } from './story-kachiing/story-kachiing.component';
import { AddProductComponent } from '../admin/sub-admin/add-product/add-product.component';
import { ChatbotService } from '../shareModule/component/chat/chatbot/chatbot.service';
import { FaqChatKachiingComponent } from './faq-chat-kachiing/faq-chat-kachiing.component';
import { EstimatorModalComponent } from './show-bookings/estimator-modal/estimator-modal.component';

@Component({
  selector: 'app-nearby-map',
  templateUrl: './nearby-map.component.html',
  styleUrl: './nearby-map.component.scss',
})
export class NearbyMapComponent implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild('searchModal')
  public searchModal: TemplateRef<any>;
  public searchByCategoryName = false;
  public isBottomSheetHold = false;
  public previousPointerYPosition = null;
  public selectedParentCategory = null;
  private modalRef: NgbModalRef;
  public hideCategory = false;
  public mainTitle: string = '';
  public contactWhatsapp = '';
  public isChatVisible = false;
  public hasEstimator = false;
  public shopVariantCategories = [];
  public selectedShopVariantCategory = null;
  public noShopsInSelectedCategory = false;
  public viewMode: 'product' | 'shop' = 'product';
  public hasShopProducts = false;

  @ViewChild('AddShop') addProductComponent: AddProductComponent;

  public setViewMode(mode: 'product' | 'shop', setUrl = true, fetchProducts = true) {
    this.viewMode = mode;
    if(setUrl){
      this.setURLBasedOnSelectedTypesAndSettings()
    }
    if (mode === 'product') {
      this.selectedShopVariantCategory = null;
    }
    if(fetchProducts){ //be careful might cause recursion here don't remove
        this.fetchProducts()
    }
  }
  public modeDisplayNames = {
    regionCrown: 'Popular(region)',
    products: 'Popular(overall)',
  };
  @ViewChild('wrapper')
  public wrapperElement: ElementRef;
  public backgroundColor = 'transparent';
  public mapHeaderColor = 'var(--primary)';
  public homepageColorStyle: any = {};
  public isChatAllowed = false;

  public chatBadWords = [];

  public bannedWordToBeAdded: string = '';

  public chatMode: 'ADMIN' | 'ALL' | 'TYPE-GROUP' = 'TYPE-GROUP';
  public readonly ADMIN_CHAT_ID = 2;
  public encodedSingleImage = '';
  public selectedNewVariantCategoryImage = null;
  public newVariationCategoryName = '';
  public newVarCatPriority = null;
  public isEditingVariantCategory = false;

  public bookingData: any = {
    title: 'Book with Kachiing!',
    icon: '',
    description:
      'Turns every booking into a win! Get instant cashback, rewards, and special discounts whenever you reserve with us.',
    color: 'primary',
    contentButtonMobile: false,
    buttonMobileText: '',
    bookNowText: 'Book Now',
  };

  public shareWithOtherTitle: string = 'Share with Others';

  public adImageState: 'entering' | 'visible' | 'exiting' = 'visible';
  public adImageLeftState: 'entering' | 'visible' | 'exiting' = 'visible';
  private readonly _adAnimationDelay = 200;

  public async setNewVariantCategoryImage(event) {
    [this.encodedSingleImage, this.selectedNewVariantCategoryImage] =
      await this.commonService.convertImageToURL(event);
  }

  public submitVariationCategory() {
    const { isType, id } = this.getCurrentSelectedTypeAndId();

    let subs;
    if (this.isEditingVariantCategory) {
      //subs = this.auth.editVariantCategory(fd)
      
      const payload = new FormData()
      payload.append('categoryId', this.selectedShopVariantCategory?.id);
      payload.append('name', this.newVariationCategoryName)
      payload.append('priority',  this.newVarCatPriority,)

      if(this.selectedNewVariantCategoryImage){
       payload.append('image', this.selectedNewVariantCategoryImage);
      }
      subs = this.auth.editVariantCategory(payload);
      // subs = this.auth.editVariationOfProduct({
      //   variantId: this.selectedVariant?.id,  varPrice: this.newVarPrice, varName: this.newVarName, varDescr: this.newVarDescr
      // })
    } else {
      subs = this.auth.createVariantCategory(
        null,
        this.selectedNewVariantCategoryImage,
        this.newVariationCategoryName,
        this.newVarCatPriority,

        {
          typeOrCategory: isType ? 'TYPE' : 'CATEGORY',
          typeOrCategoryId: id,
        },
      );
    }

    subs.subscribe({
      next: () => {
        this.toastr.success('done!');
        this.modalRef?.close();
        this.fetchShopVariantCategories();
      },
      error: (error) => {
        this.toastr.error(error.error.message);
      },
    });
  }

  public deleteVariantCategory() {
    Swal.fire({
      title: 'Delete?',
      text: 'Are your sure?',
      icon: 'warning',
    }).then((res) => {
      if (res.isConfirmed) {
        this.auth
          .deleteVariantCategory(this.selectedShopVariantCategory?.id)
          .subscribe({
            next: () => {
              this.modalRef?.close();
              //this.bottomSheetRef?.dismiss()
              this.fetchShopVariantCategories();
              this.toastr.success('Deleted');
              this.fetchProducts()
            },
          });
      }
    });
  }

  public editVariantCategoryFromChip(cat, event){
    event?.stopPropagation();
    if (!cat?.id) {
      return;
    }
    this.isEditingVariantCategory = true;
    this.selectedShopVariantCategory = cat;
    this.newVarCatPriority = this.selectedShopVariantCategory?.priority;
    this.newVariationCategoryName = this.selectedShopVariantCategory?.name


  }
  public deleteVariantCategoryFromChip(cat: any, event: Event) {
    event?.stopPropagation();
    if (!cat?.id) {
      return;
    }

    Swal.fire({
      title: `Delete ${cat?.name}?`,
      text: 'This category will be removed for this variant.',
      icon: 'warning',
      confirmButtonText: 'Delete',
      showCancelButton: true,
    }).then((res) => {
      if (res.isConfirmed) {
        this.auth.deleteVariantCategory(cat.id).subscribe({
          next: () => {
            if (this.selectedShopVariantCategory?.id === cat.id) {
              this.selectedShopVariantCategory = null;
            }
            this.fetchShopVariantCategories();
            this.toastr.success('Deleted');
          },
          error: (error) => this.toastr.error(error?.error?.message || 'Unable to delete'),
        });
      }
    });
  }

  fetchShopVariantCategories() {
    const { id, isType } = this.getCurrentSelectedTypeAndId();
    this.auth
      .getVariantCategories(null, isType ? 'TYPE' : 'CATEGORY', id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.shopVariantCategories = data.body;
        },
        error: (error) => {
          this.toastr.error(error.error.message);
        },
      });
  }
  hideNav() {
    this.scrollToBottom();

    setTimeout(() => {
      this.hideCategory = !this.hideCategory;
      if (this.getCurrentSelectedTypeAndId().isType) {
      } else {
        this.fetchProducts();
      }
      // this.location.replaceState(
      //   '/map?' + this.buildQueryParams(this.\).toString(),
      // );
      this.setURLBasedOnSelectedTypesAndSettings();
    }, 500);
  }
  public handleBottomHeaderHoldByPointer(event: MouseEvent) {
    this.isBottomSheetHold = true;
    this.previousPointerYPosition = event.clientY;
    if (this.isMobile && this.wrapperElement) {
      //(this.wrapperElement.nativeElement as HTMLElement).style.overflowY = 'scroll'
    }

    this.cdr.detectChanges();
  }
  public swiper;

  public onPageSwiper(swiper) {
    this.swiper = swiper;
  }
  goBackPage() {
    if (this.swiper.activeIndex === 2) {
      this.swiper.slideTo(1);
      return;
    }
    if (this.swiper.activeIndex === 1) {
      this.swiper.slideTo(0);
    }
  }

  private _mainTitleSubscription: Subscription;

  // public async logout() {
  //   // const resp = await this.local.confirmYesNo({
  //   //   title: 'Are you sure you want to logout?',
  //   //   text: '',
  //   //   icon: 'warning',
  //   // });
  //   // if (!resp.isConfirmed) {
  //   //   return;
  //   // }
  //   this.local.logout();
  // }
  public handleBottomHeaderLetGoByPointer(event) {
    this.isBottomSheetHold = false;
    this.previousPointerYPosition = null;

    // if(this.isMobile && this.wrapperElement){
    //   (this.wrapperElement.nativeElement as HTMLElement).style.overflowY = 'hidden'
    // }

    this.cdr.detectChanges();
  }

  public handleBottomHeaderPointerMove(event: MouseEvent) {
    if (!this.isBottomSheetHold) {
      return;
    }
    if (!this.previousPointerYPosition) {
      console.error('Error invalid y pos saved!');
      return;
    }
    const yNow = event.clientY;
    const diff = yNow - this.previousPointerYPosition; //since direction is reversed for this and 10 cause to make it more fast

    // console.log({diff})
    if (Math.abs(diff) < 50) {
      //not too sensitive not too dumb. past value: 100, 70-> too strong iphone 40 -> too fast iphone
      return;
    } else if (diff > 0) {
      this.scrollToBottom();
    } else {
      this.scrollToTopOfCategory();
    }

    // console.log('scrollingBy', diff)
    // this.previousPointerYPosition = yNow;

    // const wrapperElementHTML  = document.getElementById('wrapper');
    // wrapperElementHTML.style.overflow = 'scroll';

    // (wrapperElementHTML).scrollBy(0 , diff)
    // wrapperElementHTML.style.overflow = 'hidden';

    // console.log({wrapperElementHTML})
  }

  public regionCounts = {}; //used as a hash map to store counts with keys like '${subRegionId}x${categoryId} or ${subRegionId}xT${typeId}
  private _activeModal?: NgbModalRef | MatBottomSheet = null;

  openSearchModal() {
    this._activeModal = this.modalService.open(this.searchModal);
    //this.viewProduct(this.productsList[0])
  }

  closeActiveModal() {
    this._activeModal?.dismiss();
    this._activeModal = null;
  }

  public searchSuggestions = [];
  private _initLoaded = false;

  private _resetMapLocationTo(latLong) {
    this.googleMapsService.usersLatLong = latLong;
    this.googleMapsService.reCenter();
    this.fetchProducts();
  }
  private _promptLocation() {
    Swal.fire({
      title: 'Location',
      text: 'Please Input your current location in order to get services near you',
      input: 'number',
      confirmButtonText: 'Confirm',
      showCancelButton: true,
      cancelButtonText: 'Use My current location instead',
      inputValidator: (input) => {
        if (!(input.length == 0 || input.length == 6)) {
          return false;
        }
      },
    }).then((res) => {
      if (res.isConfirmed) {
        this.local
          .getLatLongByPostalCode(res.value)
          .then(this._resetMapLocationTo.bind(this));
      } else {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this._resetMapLocationTo({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
          },
          (error) => {
            this.toastr.error(
              'Something went wrong while trying to get location',
            );
          },
        );
      }
    });
  }

  constructor(
    public commonService: CommonService,
    private googleMapsService: GoogleMapsService,
    private auth: AuthServiceService,
    private customerService: CustomerService,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private bottomSheet: MatBottomSheet,
    private local: LocalServiceService,
    public sharedService: SharedService,
    private router: Router,
    private toastr: ToastrService,
    private roleService: RoleService,
    private location: Location,
    private store: Store<AppState>,
    private seoService: SeoService,
    private memberNotificationService: MemberNotificationService,
    private route: ActivatedRoute,
    private chatbotService: ChatbotService,
    // if this component is open in modal then this is not null
    @Optional()
    private activeModal: NgbActiveModal,
  ) { }
  ngOnInit(): void {
    this._checkIfAdmin();
    this.sharedService.openWhatsapp
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.openAdminWhatsApp();
      });

    this.store.pipe(select(selectDiscountData)).subscribe((discountData) => {
      if (discountData) {
        this.bookingData = {
          title: discountData.bookingTitle || 'Book with Kachiing!',
          icon: discountData.bookingIcon || '',
          description:
            discountData.bookingDescription ||
            'Turns every booking into a win! Get instant cashback, rewards, and special discounts whenever you reserve with us.',
          color: discountData.bookingColor || 'primary',
          contentButtonMobile: discountData.contentButtonMobile || false,
          buttonMobileText: discountData.buttonMobileText || '',
          bookNowText: discountData.bookNowText || 'Book Now',
          showBiggerBanner: discountData.showBiggerBanner || false,
        };
        this.shareWithOtherTitle =
          discountData.shareWithOtherTitle || 'Share with Others';
        this.cdr.detectChanges();
      }

      this.commonService.getPopupImages(this.comicChatFilter);
      this.commonService.getMapCustomization(this.comicChatFilter);
    });
  }
  private destroy$ = new Subject<void>();
  ngOnDestroy(): void {
    this._markerClickSubscription?.unsubscribe();
    this._scrollListenSubscriber?.unsubscribe();
    this._panSubscription?.unsubscribe();
    this._roleSubscription?.unsubscribe();
    this.local.clearTimeout(this.timeoutBookingModal);

    // if (this.sharedService.isBrowser()) {
    //   const wizard = document.getElementsByClassName('logout-wiz');
    //   if (wizard.length) {
    //     (wizard[0] as any).style.display = 'block';
    //   }
    // }
    this._disposeAds();
    this.destroy$.next();
    this.destroy$.complete();
  }
  public isSeen = false;
  public searchText = '';
  public openSuggestionText(text) {
    // console.log('opening text', text);
    this.searchText = text;
    this.searchByCategoryName = true;
    this._activeModal?.dismiss();
    this.selectedMapCategory = null;
    this.setMode('products');
    this.fetchProducts({ removeSearchTextAfterFetch: true });
  }

  private _mode:
    | 'promos'
    | 'products'
    | 'youtube'
    | 'affordable'
    | 'Hidden Gem' = 'products';
  public get mode() {
    return this._mode;
  }
  public setMode(
    mode: 'promos' | 'products' | 'youtube' | 'affordable' | 'Hidden Gem',
  ) {
    this._mode = mode;
    this.isSeen = false;
    this.clearFilterSearch();
    if (mode == 'promos') {
      this.productsList = this.allProducts.filter(
        (product) => product?.productMoreServices?.length,
      );
    } else {
      this.productsList = this.allProducts;
    }
    let correctedMode: any = this._mode;
    if (!['promos', 'products'].includes(this._mode)) {
      correctedMode = 'products'; //youtube/affordable are still
      //this.fetchProducts()
    }
    //no need to refetch products here we just hide/show products base on if they have promos
    this.googleMapsService.addProductDataToMap(
      this.productsList,
      correctedMode,
    );

    this.googleMapsService.addUsersMarkerOnMap(false);

    this.cdr.detectChanges();
  }

  //this is made to be called from outside when used as modal
  public search(searchText, searchByCategoryName, closeActiveModal = false) {
    //return
    setTimeout(() => {
      this.searchText = searchText;
      this.searchByCategoryName = searchByCategoryName;
      this.selectedMapCategory = null;
      this.fetchProducts();
      //console.log('selectedMapCategory', this.selectedMapCategory);
      if (this.closeActiveModal) {
        this._activeModal?.dismiss();
      }
    }, 800);
  }
  public goBack() {
    if (this.activeModal) {
      this.activeModal.close();
    } else {
      this.commonService.goBack();
    }
  }

  public goBackFromSubCategory() {
    if (this.isSelectSubCat && this.selectedMapCategory) {
      // Find parent category
      const parentCategory = this.mapCategories.find(
        (cat) => cat.id == this.selectedMapCategory.categorieParentId,
      );

      if (parentCategory) {
        this.loadMapCategory(parentCategory);
        this.isSelectSubCat = false;
        this.selectedParentCategory = null;
      } else {
        // If no parent, reset to main view
        this.selectedMapCategory = null;
        this.isSelectSubCat = false;
        this.selectedParentCategory = null;
        this.fetchProducts({ removeSearchTextAfterFetch: true });
      }
    }
  }

  public getSearchSuggestions(event) {
    const isAscii = event.key?.length === 1; //called for backspace and stuff so not reliable

    const term = event.target.value;
    if (term.length + (isAscii ? 1 : 0) < 3) {
      this.searchSuggestions = [];
      return;
    }
    this.auth
      .getSearchSuggestions(term + (isAscii ? event.key : ''))

      .subscribe({
        next: (data) => {
          this.searchSuggestions = (data.body ?? []).slice(0, 4);
          this.cdr.detectChanges();
        },
        error: console.error,
      });
  }
  private _latLong = null;
  // public async geoCodePostalCode() {
  //   const user = this.local.getUser();
  //   if (!user) {
  //     return;
  //   }
  //   this._latLong = await this.local.getLatLongByPostalCode(user.postalCode);
  // }
  public imgUrl = environment.ImageUrl;
  public productsList = [];
  public filteredProducts: any[] | null = null;
  public allProducts = [];
  public isLoading = false;
  public isLogin = false;
  public filterSearchText = '';
  public isFilterInputActive = false;
  public selectedRegion: string | null = null;
  public regions = [
    { value: 'north', label: 'North' },
    { value: 'central', label: 'Central' },
    { value: 'east', label: 'East' },
    { value: 'west', label: 'West' },
    { value: 'north-east', label: 'North-East' }
  ];

  public selectRegion(region: string | null) {
    if (this.selectedRegion === region) {
      // If clicking the same region, deselect it
      this.selectedRegion = null;
    } else {
      this.selectedRegion = region;
    }
    this.applyFilters();
  }

  public filterProducts(searchText: string) {
    this.filterSearchText = searchText;
    this.applyFilters();
  }

  private applyFilters() {
    const term = this.filterSearchText?.trim();

    // If no filters are active, show all products
    if (!term && !this.selectedRegion) {
      this.filteredProducts = null;
      this.isFilterInputActive = false;
      this.cdr.detectChanges();
      return;
    }

    // Apply filters
    this.filteredProducts = this.productsList.filter((prod) => {
      // Apply search text filter
      let matchesSearch = true;
      if (term) {
        matchesSearch = this.commonService.doesProductMatch(prod, term);
      }

      // Apply region filter
      let matchesRegion = true;
      if (this.selectedRegion) {
        const subRegionName = (prod.subRegionName || '').toLowerCase();
        const regionLower = this.selectedRegion.toLowerCase();
        
        // Check if subRegionName contains the selected region
        // Handle "north-east" and "north east" variations
        if (regionLower === 'north-east' || regionLower === 'north east') {
          matchesRegion = subRegionName.includes('north') && subRegionName.includes('east');
        } else {
          matchesRegion = subRegionName.includes(regionLower);
        }
      }

      return matchesSearch && matchesRegion;
    });

    this.cdr.detectChanges();
  }

  private _sortProductsByInfo(productsList: any[]) {
    this._initAdsInterval();
    const  sortedProducts =  productsList.sort((a, b) => {
      const infoB = this.commonService.getProductInformationScore(b);
      const infoA = this.commonService.getProductInformationScore(a);

      return infoB - infoA;
    });
    this.hasShopProducts = sortedProducts.some(product => product.isTypeShop);

    
    if(!this.hasShopProducts && !this.isAdmin){
      this.setViewMode('product', true, false)
    }
    return sortedProducts;
  }

  private _userSubscription?: Subscription = null;

  public clickId(id) {
    document.getElementById(id).click();
  }
  public favoriteProduct(product) {
    if (this.isLogin) {
      if (!product.isFavorite) {
        const title = 'Favorites';
        const text = 'Add to Favorites ';
        this.local.confirmYesNo({ title, text, icon: 'question' }).then((c) => {
          if (c.isConfirmed) {
            this.favProduct(product);
          }
        });
      } else {
        this.favProduct(product);
      }
    } else {
      document.getElementById('loginBtn').click();
    }
  }
  //public currentRadius: any = 30;
  // public availableRadius = [1, 2, 5, 10];

  // private readonly _distanceToZoomArr: [string, number][] = [
  //   ['1', 16], // Very close — high zoom
  //   ['2', 15],
  //   ['5', 14],
  //   ['10', 13],
  //   // ['20', 12],
  // ];

  // public availableRadius = [
  //   1, 2, 5, 10, 30
  //   //20, 50,
  //   //100, 200
  // ];

  // explicit mapping of radius (string) -> zoom level (number)
  // These zoom values are typical approximations (1 km -> high zoom, bigger radii -> smaller zoom)
  // private get _distanceToZoomArr(): [string, number][] {
  //   if (this.isMobile) {
  //     return [
  //       ['1', 14],
  //       ['2', 13],
  //       ['5', 12],
  //       ['10', 11],
  //       ['30',  11],
  //     ]
  //   }
  //   return [
  //     ['1', 15], // very close — high zoom
  //     ['2', 14],
  //     ['5', 13],
  //     ['10', 12],
  //     ['30',  11],
  //     // ['50',  10],
  //     // ['100', 10],
  //     // ['200', 9],
  //   ];
  // }
  // public get distsLen() {
  //   return this._distanceToZoomArr.length;
  // }

  private _distanceIndex = 3;
  public get distanceIndex() {
    return this._distanceIndex;
  }
  //private _setDistance(refreshProduct = true) {
  /// this.currentRadius = this.availableRadius[this._distanceIndex];

  //const newZoom =
  // this._distanceToZoomArr[this._distanceIndex]?.at(1) ??
  // 10 - (this.isMobile ? 2 : 0);
  // this.googleMapsService.reCenter(
  //   Number(this._distanceToZoomArr[this._distanceIndex]?.at(0) ?? 1),
  // );
  // this.cdr.detectChanges();
  // console.log(
  //   'seeting current zoom to ',
  //   newZoom,
  //   'currentRadius is',
  //   this.currentRadius,
  // );

  // this.googleMapsService.setZoom(newZoom as number);
  // if (refreshProduct) {
  //   this.fetchProducts();
  // }
  //}
  // private _setApproxRadiusToZoom(mapZoom) {
  //   if (!mapZoom) {
  //     console.error('Invalid mapZoom given', mapZoom);
  //     return;
  //   }
  //   let val = '1';
  //   for (const [rad, zoom] of this._distanceToZoomArr) {
  //     if (mapZoom <= zoom) {
  //       val = rad;
  //     } else {
  //       break;
  //     }
  //   }
  //   // this.currentRadius = val;
  //   console.log('currentRadius changed to', val);
  //   this.cdr.detectChanges();
  // }
  // public moduloDecreaseRadius(refreshProduct = true) {
  //   if (this._distanceIndex == 0) {
  //     return;
  //   }
  //   this._distanceIndex--;
  //   this._setDistance(refreshProduct);
  // }

  // public moduloIncreaseRadius(refreshProduct = true) {
  //   this._distanceIndex++;
  //   this._distanceIndex %= this.availableRadius.length;
  //   this._setDistance(refreshProduct);
  // }
  //  private _userLatLong = null;

  @ViewChild('marketplace') marketplacePage: MarketplacePageComponent;
  public viewProduct(product) {
    this.marketplacePage.enableMemberShop = true;
    this.marketplacePage.viewProduct(product, false);
    //this.router.navigateByUrl(`/product/${product.slug}`)
  }

  private favProduct(product) {
    this.auth
      .marketplace_favorite_product({
        member_product_id: product.id,
        isAdmin: false,
      })

      .subscribe((response: any) => {
        product.isFavorite = !product.isFavorite;
        if (product.isFavorite) {
          product.foodFavoritesCount++;
        } else {
          product.foodFavoritesCount--;
        }
        if (product.isProfile) {
          this.sharedService.triggerProfileService({});
        }
        this.cdr.detectChanges();
      });
  }
  @ViewChild('map') mapElement;

  public scrollToTop(closeInfoWindow = true) {
    if (!this.sharedService.isBrowser()) {
      return;
    }
    try {
      // document.getElementById('wrapper').scrollTo({
      //   top:  document.body.scrollHeight * 0.9,
      //   behavior: 'smooth', // optional for smooth scrolling
      // });
      this.scrollToTopOfCategory();
      if (closeInfoWindow) {
        this.googleMapsService.closeCurrentInfoWinddow();
      }
      this.isAtTop = false;
    } catch (e) {
      console.error(e);
    }
  }

  public scrollToBottom() {
    if (!this.sharedService.isBrowser()) {
      return;
    }

    try {
      this.wrapperElement?.nativeElement?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
      this.isAtTop = true;
    } catch (e) {
      console.error(e);
    }
  }
  public mapCategories = [];
  public mapSubCategories = [];

  private getLocationCondition() {
    if (this.hideCategory) {
      return {};
    }
    return {
      locationCondition: {
        fromLat: this.mapBounds.fromLat,
        toLat: this.mapBounds.toLat,
        fromLng: this.mapBounds.fromLng,
        toLng: this.mapBounds.toLng,
        center: this.googleMapsService.getCenter(),

        mapWidth: this.googleMapsService.getMapWidth(),
        mapHeight: this.googleMapsService.getMapHeight(),
      },
    };
  }

  private processParams() {
    let subCatSlug = '',
      mainCatSlug = '',
      typeSlug = '';

    const routeParams = (this.route.firstChild || this.route).snapshot.paramMap;
    const viewMode = routeParams.get('viewMode');
    console.log({routeParams})
    if (routeParams?.has('prefixedSlug')) {
      const prefixSlug = routeParams.get('prefixedSlug');
     
      console.log('it has prefixedSlug', prefixSlug);
      const firstHyphenIndex = prefixSlug?.indexOf('-');
      if (firstHyphenIndex != -1) {
        const prefix = prefixSlug?.substring(0, firstHyphenIndex);
        const slug = prefixSlug?.substring(firstHyphenIndex + 1);
        switch (prefix) {
          case 't': {
            typeSlug = slug;
            break;
          }
          case 's': {
            subCatSlug = slug;
            break;
          }
          case 'c': {
            mainCatSlug = slug;
            break;
          }
        }
      }
    } else {
      console.log('NO URL PARAMS');
    }
    const url = new URL(window.location.href);

    const hideCategory = url.searchParams.get('hideCategory');

    if (hideCategory == '1') {
      this.hideCategory = true;
    } else {
      this.hideCategory = false;
    }

    const searchText = url.searchParams.get('search');

    const isCategoryOnlySearch = !!url.searchParams.get('isCategoryOnlySearch');

    return {
      subCatSlug,
      mainCatSlug,
      typeSlug,
      searchText,
      isCategoryOnlySearch,
      viewMode
    };
  }
  private getCategoryAndParentBySlug(slug: string, isSubCat = false) {
    if (isSubCat) {
      for (const parent of this.mapCategories) {
        for (const subCat of parent.subCategory) {
          if (
            subCat?.slug?.trim()?.toLowerCase() == slug?.trim()?.toLowerCase()
          ) {
            return { parent, category: subCat };
          }
        }
      }
    } else {
      return {
        parent: null,
        category: this.mapCategories.find(
          (cat) =>
            cat?.slug?.toLowerCase()?.trim() == slug?.toLowerCase()?.trim(),
        ),
      };
    }
    return { parent: null, category: null };
  }

  private setupSEO() {
    if (this.currentSelectedTypes?.length) {
      this.mainTitle = this.currentSelectedTypes[0].name;
    } else if (this.selectedMapCategory) {
      this.mainTitle =
        this.selectedMapCategory?.name ||
        this.selectedMapCategory?.categoryName;
    }

    this.seoService.update({
      title: this.mainTitle,
      main_title: ' | BEST SERVICES SG',
    });
  }
  private processTypeSlug(typeSlug) {
    this.auth.getTypeBySlug(typeSlug).subscribe({
      next: (res: any) => {
        const selectedType = res.data;
        console.log({ res });
        if (selectedType) {
          this.currentSelectedTypes.push(selectedType);
          console.log(
            'There is a selected type',
            selectedType.memberShopCategory?.slug,
          );
          const { parent, category } = this.getCategoryAndParentBySlug(
            selectedType.memberShopCategory?.slug,
            true,
          );
          this.mapSubCategories = parent?.subCategory ?? [];

          this.selectedMapCategory = category;
          this.selectedParentCategory = parent;
          this.isSelectSubCat = true;

          this.auth
            .fetchProductsBasedOnTypes({
              types: [selectedType.id],
              ...this.getLocationCondition(),
            })
            .subscribe({
              next: (data: any) => {
                this._getBookingMoreInfos(this.currentSelectedTypes[0]);
                this._getCountsOfProductsInSubCategories();
                this.scrollToTopOfCategory();
                this.clearFilterSearch();
                this.productsList = this._sortProductsByInfo(data.data);
                // this.setupBgColor();
                this.setupBookingData();
                this.googleMapsService.addProductDataToMap(
                  this.productsList,
                  'products',
                );
                this.googleMapsService.addUsersMarkerOnMap(false);

                this.cdr.detectChanges();
              },
            });
        } else {
          console.log('there is no selected typer');
        }
      },
    });
  }
  private setupBookingQuestions() {
    if (this.selectedMapCategory) {
      try {
        this.currentCategoryBookingQuestions = JSON.parse(
          this.selectedMapCategory.mapQuestions ?? '[]',
        );
      } catch (e) {
        console.error(e);
      }
    }
  }

  private init() {
    if (this.sharedService.isBrowser() && !this.selectedMapCategory) {
      const {
        subCatSlug,
        mainCatSlug,
        typeSlug,
        searchText,
        isCategoryOnlySearch,
        viewMode
      } = this.processParams();

      console.log({viewMode})
      if(viewMode == 'shop'){

        console.log('view mode is shop')
        this.setViewMode('shop', false)
      }
      if (searchText) {
        this.search(searchText, isCategoryOnlySearch);
        return;
      } else if (subCatSlug) {
        console.log('going subcat');
        const { parent, category } = this.getCategoryAndParentBySlug(
          subCatSlug,
          true,
        );

        this.selectedMapCategory = category;

        this.selectedParentCategory = parent;

        this.mapSubCategories = parent?.subCategory ?? [];

        this.isSelectSubCat = true;
      } else if (mainCatSlug) {
        //console.log('fetching by main cat  ');
        console.log('going main slug');
        this.selectedMapCategory =
          this.getCategoryAndParentBySlug(mainCatSlug).category;

        this.mapSubCategories = this.selectedMapCategory?.subCategory ?? [];
      } else if (typeSlug) {
        this.processTypeSlug(typeSlug);
      }

      this.setupSEO();

      this._getBookingMoreInfos(
        this.currentSelectedTypes?.length
          ? this.currentSelectedTypes[0]
          : this.selectedMapCategory,
      );

      this.setupBookingQuestions();

      if (!typeSlug) {
        this.fetchProducts();
      }

      this.setupBookingData();
      this.setupChat();
      this.setupChatSetting();
      this.fetchShopVariantCategories();

      this.cdr.detectChanges();
    }

    // Check for query params to auto-open modals (after categories are loaded)
    this._checkAndOpenModalFromQueryParams();
  }
  private _fetchCats() {
    this.commonService.categoryList
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this.mapCategories = structuredClone(response);
        if (!this.mapCategories?.length) {
          return;
        }
        this.init();
      });
  }

  private _scrollListenSubscriber = null;

  private _addScrollListener() {
    if (!this.sharedService.isBrowser()) {
      return;
    }
    this._scrollListenSubscriber = fromEvent(window, 'scroll').subscribe({
      next: () => {
        this.checkIfIsAtTop();
      },
    });
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'ArrowDown') {
      this.scrollToBottom();
      event.preventDefault();
    } else if (event.key === 'ArrowUp') {
      this.scrollToTop();
      event.preventDefault();
    }
  }

  private _removeRepeatedLocation(products): any[] {
    const seenLocation = new Set();
    const newProds = [];
    for (const prod of products) {
      const KEY = JSON.stringify(prod.latLong);
      if (!seenLocation.has(KEY)) {
        seenLocation.add(KEY);
        newProds.push(prod);
      }
    }
    return newProds;
  }
  public isAtTop = true;
  public checkIfIsAtTop() {
    const oldValue = this.isAtTop;
    this.isAtTop =
      this.sharedService.isBrowser() && document.documentElement.scrollTop == 0;
    if (oldValue != this.isAtTop) {
      this.cdr.detectChanges();
    }
  }
  public get isMobile(): boolean {
    return this.sharedService.isBrowser() && window.innerWidth <= 968;
  }
  public openRecommendationsForm() {
    if (this.isMobile) {
      this.bottomSheet.open(RecommendationsFormComponent, {
        panelClass: 'bottom-sheet-1',
        hasBackdrop: true,
      });
    } else {
      this.modalService.open(RecommendationsFormComponent);
    }
  }

  @ViewChild('addRecommendationBtn') addRecommendationBtn: ElementRef;
  @ViewChild('cats') topCategorySelectElement: ElementRef;

  // private readonly FOOD_CAT_ID = 11;

  // public get mapCenter() {
  //   return this.googleMapsService.getCenter();
  // }
  public get mapBounds() {
    return (
      this.googleMapsService.getBounds() ?? {
        fromLat: 1.288430539736195,
        toLat: 1.4157677903460766,
        fromLng: 103.49021015625,
        toLng: 104.14938984375,
      }
    );
  }
  // public get mapZoom() {
  //   return this.googleMapsService.getZoom();
  // }

  public scrollToTopOfCategory() {
    this.topCategorySelectElement?.nativeElement?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }

  //some functionality depends on loading for first time or not
  private _isFirstTimeLoad = true;

  private setupChatSetting() {
    console.log('setting up chat');
    const { id, isType } = this.getCurrentSelectedTypeAndId();

    if (isType) {
      this.chatbotService.forTypeId = id;
      this.chatbotService.forCategoryId = null;
    } else {
      this.chatbotService.forCategoryId = id;
      this.chatbotService.forTypeId = null;
    }
    this.chatbotService.chatTotalUnreadCount$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.totalUnreadMessagesCount = data;
      });
    this.chatbotService.updateTotalUnreadMessagesCount();
  }

  public showProductLocationOnMap(product) {
    this.googleMapsService.openInfoWindowOfProduct(product);
    this.googleMapsService.panTo(product.latLong);
    this.googleMapsService.setZoom(15);
    this.scrollToBottom();
  }

  ///scrollToBottomOfProducts will make the bottom sheet open when search is done
  public async fetchProducts({
    scrollToBottomProducts = true,
    removeSearchTextAfterFetch = false,
  } = {}) {
    //console.trace();
    try {
      // if(this.sharedService.isBrowser() ){
      //   await this.geoCodePostalCode()
      // }
      this.currentSelectedTypes = [];

      if (!this.sharedService.isBrowser()) {
        return; //no need to call when not on browser
      }
      if (!this.mapBounds) {
        console.error('map not inited!');
        return;
      }
      // console.log('map center', this.googleMapsService.getCenter())
      this.closeActiveModal();
      this.isLoading = true;
      this.cdr.detectChanges();

      //console.log('userLatLong', this._userLatLong, typeof this._userLatLong);

      const payload = {
        basedProduct: this.viewMode == 'shop' ? 'shop-promo' : 'all',
        search: this.searchText,
        searchByCategoryName: this.searchByCategoryName,
        //basedProduct: 'all',
        // radius: this.currentRadius./(),
        limit: 100,
        ...(this._latLong ?? []),

        ...(this.hideCategory
          ? {}
          : this.getLocationCondition().locationCondition),
      };
      if (
        ['youtube', 'affordable', 'regionCrown', 'Hidden Gem'].includes(
          this._mode,
        )
      ) {
        payload.orderBy = this._mode;
      }

      if (this.selectedMapCategory) {
        if (this.isSelectSubCat) {
          payload.categoryId = this.selectedMapCategory?.categorieChildId;
        } else {
          payload.categoryId = this.selectedMapCategory?.id;
        }
      } else if (this._isFirstTimeLoad) {
        payload.categoryId = this.selectedMapCategory?.id;
      }
      //console.log({payload})

      this.customerService
        .getMemberShopProductList(payload)
        //.pipe(debounceTime(200))
        .subscribe({
          next: (data) => {
            this._isFirstTimeLoad = false;

            this.allProducts = data.body.data;

            this.allProducts = this._sortProductsByInfo(this.allProducts);

            if (data.body.fetchedCategory) {
              if (removeSearchTextAfterFetch) {
                this.searchText = '';
              }
              if (data.body.fetchedCategory?.parentCategoryId) {
                const parentCategory = this.mapCategories.find(
                  (cat) =>
                    cat.id == data.body.fetchedCategory?.parentCategoryId,
                );
                this.selectedParentCategory = parentCategory;
                this.mapSubCategories = parentCategory.subCategory;
                this.selectedMapCategory = this.mapSubCategories.find(
                  (cat) => cat.categorieChildId == data.body.fetchedCategory.id,
                );
                this.isSelectSubCat = true;
              } else {
                this.selectedMapCategory = this.mapCategories.find(
                  (cat) => cat.id == data.body.fetchedCategory.id,
                );
                this.mapSubCategories = this.selectedMapCategory.subCategory;
              }
              this.fetchShopVariantCategories();
            }
            this.setMode(this.mode);
            let correctedMode: any = this._mode;
            if (!['promos', 'products'].includes(this._mode)) {
              correctedMode = 'products';
            }

            this.googleMapsService.addProductDataToMap(
              this.productsList,
              correctedMode,
            );
            this.googleMapsService.addUsersMarkerOnMap(false);

            this._getCountsOfProductsInSubCategories();

            this._initLoaded = true;
            this.isLoading = false;
            // if (!this.isMobile) {
            //   timer(1000).subscribe(() => {
            //     if (this.productsList.length == 0) {
            //       // this.addRecommendationBtn?.nativeElement?.scrollIntoView();
            //       this.scroll()
            //     }
            //     this.cdr.detectChanges();
            //   });

            // }

            // if (this.productsList.length == 0 && scrollToBottomProducts) {
            //   timer(1000).subscribe(() => {
            //     this.scrollToTopOfCategory();
            //   });
            // }
            // if (scrollToBottomProducts) {
            //   setTimeout(() => {
            //     this.scrollToTopOfCategory();
            //   });
            // }

            // if (this.searchByCategoryName) {
            //   this.searchText = '';
            // }
            this.searchByCategoryName = false; //since only needed when starting then  can be reset back using the inside search
          },
          error: (error) => {
            this._initLoaded = true;
            this.isLoading = false;
            console.error(error.error.message);
          },
        });
    } catch (e) {
      console.error(e);
    }
  }
  public productBasedPromos = [];

  private _fetchAllProductBasedPromo() {
    this.auth
      .getAllProductBasedPromo(this.local.getUser()?.region ?? 42)
      .subscribe({
        next: (data) => {
          this.productBasedPromos = data.body;
        },
        error: console.error,
      });
  }

  public promos = [];
  private _fetchPromos() {
    this.auth
      .getAllUpgradedPromo(this.local.getUser()?.region ?? 42)
      .subscribe({
        next: (data) => {
          this.promos = data.body;
        },
        error: console.error,
      });
  }

  private _getCountsOfProductsInSubCategories() {
    // const mapCenter = this.mapCenter

    if (!this.mapBounds) {
      //console.log('map bounds is null!');
      return;
    }
    let payload = {
      search: this.searchText,
      categoryId: this.selectedMapCategory?.id,

      fromLat: this.mapBounds.fromLat,
      toLat: this.mapBounds.toLat,
      fromLng: this.mapBounds.fromLng,
      toLng: this.mapBounds.toLng,
    };
    ///console.log("Payload is", payload)
    this.regionCounts = {};

    if (this.isSelectSubCat) {
      payload.categoryId = this.selectedMapCategory?.categorieChildId;
    } else {
      payload.categoryId = this.selectedMapCategory?.id;
    }
    this.auth.getRadiusBasedProductCounts(payload).subscribe({
      next: (data) => {
        for (const product of data.body) {
          const key = this.commonService.getProductCountsKey('', {
            subCatId: product.categoryId,
          });
          this.regionCounts[key] ??= 0;
          this.regionCounts[key] = product.count;
        }
      },
      error: () => {
        for (const product of this.productsList) {
          const key = this.commonService.getProductCountsKey('', {
            subCatId: product.categoryId,
          });
          this.regionCounts[key] ??= 0;
          this.regionCounts[key] += 1;
        }
      },
    });

    // console.log('regionCounts', this.regionCounts);
  }

  @ViewChild('SignIn', { static: false }) signIn: SignInComponent;
  public openLoginForm() {
    this.signIn.loginStage = '';
    this.signIn.openSignInPopup();
  }
  public bottomTabs = [{ title: 'Products' }, { title: 'Promos' }];
  private _markerClickSubscription: Subscription = null;
  private _panSubscription: Subscription = null;

  private map = null;

  public reCenter() {
    if (
      this.sharedService.isBrowser() &&
      !this.local.getUser() &&
      !this.googleMapsService.usersLatLong
    ) {
      //if not logged in and has not already input the location of the user then we ask either for location or
      this._promptLocation();
    } else {
      this.googleMapsService.reCenter();
    }
  }
  // public get isOnModal() {
  //   //console.log(!!this.activeModal)
  //   return !!this.activeModal;
  // }
  public isAdmin = false;
  private _roleSubscription = null;
  private _checkIfAdmin() {
    this._roleSubscription = this.roleService.rolesSubject.subscribe(() => {
      this.isAdmin = !!this.roleService?.roles?.userType.includes('ADMIN');
      if (this.isAdmin) {
        this.getBadWords();
      }

      // if (this.isAdmin) {
      //   this.chatMode = 'ALL';
      // }
      this.cdr.detectChanges();
    });
    this.roleService.getUserRoles(
      this.local.getUser()?.level,
      this.local.getUser()?.isVerified,
    );
    // this.store
    //     .pipe(
    //       select(selectUser),
    //       filter((user) => !!user),
    //       distinctUntilChanged(
    //         (prev, curr) =>
    //           prev.level === curr.level && prev.isVerified === curr.isVerified
    //       ) // Compare previous and current values
    //     )
    // .subscribe((resp) => {

    // });
  }
  appUserId: any = 0;
  public openModal(template, others = {}) {
    this.modalRef = this.modalService.open(template, others);
  }

  public setAllowChat(checked: boolean) {
    const { id, isType } = this.getCurrentSelectedTypeAndId();
    this.auth
      .changeCategoryBookingProperty(id, 'allowChat', checked, isType)
      .subscribe({
        next: (data) => {
          this.toastr.success('chat setting changed');
          this.isChatAllowed = checked;
        },
        error: (error) => {
          this.toastr.error(error.error.message);
        },
      });
  }

  getBadWords() {
    this.auth.get_bad_words().subscribe((data: any) => {
      this.chatBadWords = data.data;
    });
  }

  removeBannedWord = (event: MouseEvent) => {
    const target = event.currentTarget as HTMLElement;

    //console.log(Array.from(target.attributes), target);
    const word = target.getAttribute('wordcontent');
    this.auth.remove_bad_word(word).subscribe(
      (data) => {
        this.toastr.show('Word Removed');
        this.getBadWords();
      },
      (err) => {
        this.toastr.error('Error while Removing banned word');
        console.error(err);
      },
    );
  };

  submitBadWord = () => {
    if (!this.bannedWordToBeAdded) {
      return;
    }
    this.auth.add_bad_word(this.bannedWordToBeAdded).subscribe(
      (data) => {
        this.toastr.show('Banned word added');
        this.getBadWords();
        this.bannedWordToBeAdded = '';
      },
      (err) => {
        this.toastr.error('Error while adding banned word');
        console.error(err);
        this.bannedWordToBeAdded = '';
      },
    );
  };
  ngAfterViewInit(): void {
    this._addScrollListener();
    this._fetchAnsweredQuestions();
    this._fetchPromos();

    //this._fetchAllProductBasedPromo();
    if (!this.sharedService.isBrowser()) {
      return;
    }
    this._initAdsInterval();

    this.map = this.googleMapsService.createMap('map');
    this.googleMapsService.initProductMap(this.map, 'map');

    this.googleMapsService.addUsersMarkerOnMap(true);

    this._markerClickSubscription?.unsubscribe();
    this._markerClickSubscription =
      this.googleMapsService.markerClick.subscribe((product) => {
        this.viewProduct(product);
      });

    this._fetchCats();
    this.sharedService.openLoginSubject.pipe(takeUntil(this.destroy$)).subscribe(()=>{
      this.openLoginForm()
    })

    this._userSubscription?.unsubscribe();
    this._userSubscription = this.local.getUserDetailsObserver().subscribe({
      next: (user) => {
        if (user) {
          this.appUserId = user.id;
          this.isLogin = true;

          if (this.selectedMapCategory) {
            this.fetchProducts();
            this._resetMapLocationTo(this.local.getUser().latLong);
          }
          this.roleService.getUserRoles(
            this.local.getUser()?.level,
            this.local.getUser()?.isVerified,
          );

          this.cdr.detectChanges();
        } else {
          this.isLogin = false;
        }
      },
    });
    this._panSubscription?.unsubscribe();
    this._panSubscription = this.googleMapsService.panSubject
      .pipe(debounceTime(50))
      .subscribe((isZoomOut) => {
        if (this.currentSelectedTypes?.length) {
          this.setCurrentType(this.currentSelectedTypes);
        } else {
          this.fetchProducts({ scrollToBottomProducts: false });
        }
        //this._setApproxRadiusToZoom(this.mapZoom);

        // if(isZoomOut){
        //   if(this.distanceIndex != 0){
        //     this.moduloDecreaseRadius(false)

        //   }
        // }else{
        //   if(this.distanceIndex != this.distsLen-1){
        //     this.moduloIncreaseRadius(false);
        //   }

        // }
      });
    this.googleMapsService.reCenter();
    // if (this.sharedService.isBrowser()) {
    //   const wizard = document.getElementsByClassName('logout-wiz');
    //   if (wizard.length) {
    //     (wizard[0] as any).style.display = 'none';
    //   }
    // }
    if (this.sharedService.isBrowser()) {
      this._mainTitleSubscription = this.store
        .pipe(select((state) => this.mainTitle))
        .subscribe((title) => {
          if (title) {
            this.seoService.update({
              title: title,
              main_title: ' | BEST SERVICES SG',
            });
          }
          this.cdr.detectChanges();
        });
    }
    this.seoService.setRobotsIndexFollow();
  }

  public carouselOptionsCate: any = {
    spaceBetween: 2,
    slidesPerView: 'auto',
    pagination: false,
  };
  public variantCategoriesCarousel: any = {
    slidesPerView: 'auto',
    pagination: false,
    freeMode: false,
    spaceBetween: 4,
    centeredSlides: false,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    watchOverflow: true,
    breakpoints: {
      0: {
        spaceBetween: 4,
      },
      768: {
        spaceBetween: 6,
      },
      1200: {
        spaceBetween: 8,
      },
    },
  };
  carouselOptionsPage: any = {
    spaceBetween: 0,
    slidesPerView: 1,
    pagination: false,
    initialSlide: 1,
    autoHeight: false,
    // observer: true,
    // observeParents: true,
    breakpoints: {
      991: {
        slidesPerView: 'auto',
      },
    },
  };
  //public cuisineCat = null;
  public selectedMapCategory: any = null;
  public isSelectSubCat = false;

  /**************************** Code related to booking  ***************************************/

  public bookingProductsLoaded = false;
  public bookingResultProducts = [];
  public currentCategoryBookingQuestions = [];
  public alreadyAnsweredQuestions?: Set<string>;
  public areThereBookingQuestion = false;
  public currentCategoryTagList: string[] = [];
  public newTagText = '';

  public isProductVisible(product) {
    if (product?.isAd) {
      return this.isLogin
    }

    // Filter by view mode (product/shop)
    if (this.viewMode === 'shop') {
      // Only show shop products (products with variantCategoryId)
      if (!product?.variantCategoryId) {
        return false;
      }
      // Check if product is approved (unless admin)
      if (!this.isAdmin && !product.isTypeShopApproved) {
        return false;
      }
      // Filter by selected variant category if one is selected
      if (this.selectedShopVariantCategory) {
        return product?.variantCategoryId == this.selectedShopVariantCategory?.id;
      }
    } else {
      // Only show regular products (products without variantCategoryId)
      if (product?.isTypeShop) {
        return false;
      }
    }

   
    return true

  }
  public shopProductSelected(product) {
    this.changeProductProperty(
      product,
      'isTypeShopApproved',
      product?.isTypeShopApproved ? '0' : '1',
    );
  }
  private changeProductProperty(product, key, val) {
    this.auth.setProductProperty(product?.id, key, val).subscribe({
      next: () => {
        this.fetchProducts();
        this.toastr.success('Done');
      },
      error: (error) => {
        this.toastr.error(error.error.message);
      },
    });
  }
  public openAddProductToShop() {
    // if(selectedShopVariantCategory){
    //   this.local.alertInfo({title: 'Please Make sure to select a category'})
    // }
    this.addProductComponent.getSubRegionList();
    this.addProductComponent
      .newProduct({
        memberShopProductType: 'promote',
        closeAll: false,
        addedToProductPage: null,
        isAd: false,
        isTypeShopProduct: true,
        selectedCategory: this.selectedMapCategory,
        selectedTypes: this.currentSelectedTypes,
        variantCategoryId: this.selectedShopVariantCategory?.id,

      })
      .closed.subscribe(() => {
        // window.location.reload();
        this.fetchProducts();
      });
  }

  public addAd() {
    this.addProductComponent.getSubRegionList();
    this.addProductComponent
      .newProduct({
        memberShopProductType: 'promote',
        closeAll: false,
        addedToProductPage: null,
        isAd: true,
        selectedCategory: this.selectedMapCategory,
        selectedTypes: this.currentSelectedTypes,
      })
      .closed.subscribe(() => {
        //window.location.reload();
        this.fetchProducts();
      });
  }
  private _fetchAnsweredQuestions() {
    this.auth
      .getMyMapQuestionResponse(this.currentSelectedTypes?.length)
      .subscribe({
        next: (data) => {
          this.alreadyAnsweredQuestions = new Set(
            data.body.map((response) => {
              return response.question;
            }),
          );
          this.areThereBookingQuestion =
            this.currentCategoryBookingQuestions.some((qn) => {
              return (
                !qn.isTag &&
                this.alreadyAnsweredQuestions &&
                !this.alreadyAnsweredQuestions?.has(
                  qn?.question ?? qn?.questionText,
                )
              );
            });
          this.cdr.detectChanges();
        },
      });
  }
  public openStore() {
    // Update URL to include story=1 parameter
    this._updateUrlWithQueryParam('story', '1');

    const modalRef = this.modalService.open(StoryKachiingComponent, {
      size: 'md',
      centered: true,
      backdrop: true,
      keyboard: true,
      windowClass: 'story_modal',
    });

    const componentInstance =
      modalRef.componentInstance as StoryKachiingComponent;
    componentInstance.filter = this.comicChatFilter;
    componentInstance.selectedMapCategory = this.selectedMapCategory;
    componentInstance.currentSelectedTypes = this.currentSelectedTypes;
    componentInstance.openShowBookingsModal.subscribe(() => {
      this.openShowBookingsModal();
    });
    componentInstance.openWhatsApp.subscribe(() => {
      this.openAdminWhatsApp();
    });

    // Remove query param when modal closes
    modalRef.hidden.subscribe(() => {
      this._updateUrlWithQueryParam('story', null);
    });
  }
  public openFaqChat() {
    this.modalService.open(FaqChatKachiingComponent, {
      size: 'md',
      centered: true,
      backdrop: true,
      keyboard: true,
      windowClass: 'story_modal',
    });
  }
  public openEditBooking() {
    this.modalRef = this.modalService.open(EditBookingComponent, {
      size: 'md',
      centered: true,
    });

    const componentInstance = this.modalRef
      .componentInstance as EditBookingComponent;
    componentInstance.selectedMapCategory = this.selectedMapCategory;
    componentInstance.isSelectSubCat = this.isSelectSubCat;
    componentInstance.currentSelectedTypes = this.currentSelectedTypes;
    componentInstance.filter = this.comicChatFilter;

    componentInstance.bookingSaved.subscribe((updatedData) => {
      // Update the local booking data with the saved changes
      this.currentCategoryBookingQuestions = updatedData.questions;
      this.currentCategoryTagList = updatedData.tags;
      this.currentCategoryBookingImageInfo = updatedData.imageInfo;

      // Update the selectedMapCategory with the new data
      if (this.selectedMapCategory) {
        this.selectedMapCategory.mapQuestions = JSON.stringify(
          updatedData.questions,
        );
        if (!this.selectedMapCategory.bookingMoreInfos) {
          this.selectedMapCategory.bookingMoreInfos = {};
        }
        this.selectedMapCategory.bookingMoreInfos.tagChoices = updatedData.tags;
        this.selectedMapCategory.bookingMoreInfos.taggedUsers =
          updatedData.taggedUsers;
        this.selectedMapCategory.bookingMoreInfos.uploadedImages = [
          updatedData.imageInfo,
        ];
      }

      // Trigger change detection
      this.cdr.detectChanges();

      // Also refresh category data from server for consistency
      this.commonService.refreshCategoryData();
    });

    this.modalRef.hidden.subscribe(() => {
      // this.loadMapCategory(this.selectedMapCategory, this.isSelectSubCat);
    });
  }

  public selectedTags = new Set<string>();
  public bookingTagClicked(event, tag) {
    event.stopPropagation();
    event.preventDefault();
    if (this.selectedTags.has(tag)) {
      this.selectedTags.delete(tag);
    } else {
      this.selectedTags.add(tag);
    }
  }

  public bookingSwiper = null;

  // trackBy for questions - helps preserve input focus & performance
  trackByQuestion(index: number, qn: any): any {
    return qn?.id ?? qn?.question ?? qn?.questionText ?? index;
  }

  public getCurrentSelectedTypeAndId() {
    let selectedCategoryId = this.selectedMapCategory?.id;

    if (this.isSelectSubCat) {
      selectedCategoryId = this.selectedMapCategory?.categorieChildId;
    }
    const id = this.currentSelectedTypes?.length
      ? this.currentSelectedTypes[0]?.id
      : selectedCategoryId;
    const isType = !!this.currentSelectedTypes?.length;

    return { id, isType };
  }

  // trackBy for choices - handles string getCurrentSelectedTypeAndIdor object choices
  // trackByChoice(index: number, choice: any): any {
  //   if (choice && typeof choice === 'object') {
  //     return choice.id ?? index;
  //   }
  //   // for primitive choices, return the value (stable if values don't duplicate)
  //   return choice ?? index;
  // }

  // Called when user submits form
  public openAdminWhatsApp() {
    // if (
    //   !this.contactWhatsapp ||
    //   ['undefined', 'null', '+65null', '+65undefined'].includes(
    //     this.contactWhatsapp,
    //   )
    // ) {
    //   return;
    // }
    Swal.fire({
      title: 'Still can’t decide? ',
      text: 'Ask us and let us wow u with our tips and promotions that u never knew existed. Kachiing responds as a Friend would.',
      imageUrl: '../../../../../assets/images/w.jpeg', // ensure w.jpeg is in src/assets
      imageAlt: 'w image',
      imageWidth: '6rem',
      imageHeight: '6rem',
      showCancelButton: true,
      showCloseButton: true, // <-- Add X button on top right
      confirmButtonText: `<span style="background: #23ba59; color: #fff; padding: 0.75em 1.75em; border-radius: 0.25em;"><i class="fab fa-whatsapp"></i> WhatsApp</span>`,
      cancelButtonText: `<span style="background: var(--primary); color: #fff; padding: 0.75em 1.75em; border-radius: 0.25em;"><i class="fas fa-comments"></i> In-App Chat</span>`,
      // Make sure icons are supported in your app or add to global styles
      buttonsStyling: true,
      customClass: {
        confirmButton: 'p-0',
        cancelButton: 'p-0'
      }
    }).then((res) => {
      if (res.isConfirmed) {
        window.open(`https://wa.me/${this.contactWhatsapp}`, '_blank');
      }
      // Only show chat if user chose cancel (In-App Chat), not when they closed the dialog (close button)
      if (res.dismiss === Swal.DismissReason.cancel) {
        this.isChatVisible = true;
        this.cdr.detectChanges();
        this.local.alertClose();
      }
      // If dismissed by close button (`res.dismiss === Swal.DismissReason.close`), do nothing extra.
    });
  }
  public currentBookingPage = 0;
  async submitBookingResponses() {
    this.customerService
      .getMemberShopProductList({
        limit: 10,
        basedProduct: 'all',
        containsTags: Array.from(this.selectedTags).map(
          (val) => String(val).charAt(0).toUpperCase() + String(val).slice(1),
        ),
        ...this.getLocationCondition(),
        categoryId: this.isSelectSubCat
          ? this.selectedMapCategory?.categorieChildId
          : this.selectedMapCategory?.id,
      })
      .subscribe({
        next: (data) => {
          this.bookingSwiper.slideTo(3);
          this.bookingResultProducts = this._sortProductsByInfo(data.body.data);
          this.bookingProductsLoaded = true;
        },
      });
    try {
      let selectedCategoryId = this.selectedMapCategory?.id;

      if (this.isSelectSubCat) {
        selectedCategoryId = this.selectedMapCategory?.categorieChildId;
      }

      // for (const question of this.currentCategoryBookingQuestions) {
      //   await this.auth
      //     .saveMapQuestionsResponse(
      //       this.currentSelectedTypes?.length
      //         ? this.currentSelectedTypes[0]?.id
      //         : selectedCategoryId,
      //       question.questionText ?? '',
      //       question.answer ?? '',
      //       !!this.currentSelectedTypes?.length
      //     )
      //     .toPromise();
      // }
      this.toastr.success('Saved');
      this._fetchAnsweredQuestions();
      this.cdr.detectChanges();
    } catch (e) {
      this.toastr.error(e.error.message);
    }

    // Example: call your service to persist
    // this.bookingService.saveAnswers(payload).subscribe(...)
  }

  // Reset answers to empty/initial
  resetAnswers() {
    this.currentCategoryBookingQuestions.forEach((q) => {
      // preserve default for multiple-choice if you want; here we clear everything
      q.answer = q.defaultAnswer ?? null;
    });
  }

  /**************************************************************************************************************** */

  public selectVariantCategory(cat){
   this.selectedShopVariantCategory?.id == cat?.id ? (this.selectedShopVariantCategory = null) : (this.selectedShopVariantCategory = cat)
   this.noShopsInSelectedCategory = this.productsList.every(prod => !this.isProductVisible(prod))
  }
  private clearFilterSearch() {
    this.filteredProducts = null;
    this.filterSearchText = '';
    this.isFilterInputActive = false;
    this.selectedRegion = null;
    this.noShopsInSelectedCategory = false
  }

  public clearProductFilter() {
    this.clearFilterSearch();
    this.cdr.detectChanges();
  }
  backCategory(category){
    if(this.currentSelectedTypes?.[0]?.name) {
      this.currentSelectedTypes = [];
      return;
    }
    this.loadMapCategory(category, true)
  }

  public closeSearchFilter() {
    if (this.isFilterInputActive && !this.filterSearchText) {
      this.isFilterInputActive = false;
      this.cdr.detectChanges();
    }
  }

  public async loadMapCategory(
    selectedCategory: string | any,
    isSubCat = false,
  ) {
    try {
      this.clearFilterSearch();
      this.selectedParentCategory = null;
      this.searchText = '';
      this.isSelectSubCat = isSubCat;
      let categoryParams = '';
      if (!isSubCat) {
        if (this.selectedMapCategory?.id == selectedCategory?.id) {
          this.selectedMapCategory = null;

          this.mapSubCategories = [];
          this.searchText = '';
          categoryParams = ``;
        } else {
          this.selectedMapCategory = selectedCategory;

          this.mapSubCategories = selectedCategory.subCategory;
          this.searchText = '';
          categoryParams = `cat=${this.selectedMapCategory?.slug}`;
        }
      } else if (this.selectedMapCategory == selectedCategory && isSubCat) {
        //console.log('current subcat=', this.selectedMapCategory.categorieParentId, this.mapCategories.map(cat => cat.id))
        this.selectedMapCategory = this.mapCategories.find(
          (cat) => cat.id == this.selectedMapCategory.categorieParentId,
        );
        this.isSelectSubCat = false;
        categoryParams = `cat=${this.selectedMapCategory?.slug}`;
      } else {
        this.selectedMapCategory = selectedCategory;

        const parentCat = this.mapCategories.find(
          (cat) => cat.id == this.selectedMapCategory.categorieParentId,
        );
        this.selectedParentCategory = parentCat;
      }
      //console.log('tags=', selectedCategory?.bookingMoreInfos);
      this._getBookingMoreInfos(selectedCategory);
      if (this.sharedService.isBrowser()) {
        this.setURLBasedOnSelectedTypesAndSettings();
      }

      //this.setupBgColor();
      this.setupBookingData();
      this.setupChatSetting();
      this.fetchShopVariantCategories();
      this.cdr.detectChanges();
      // console.log("selected cat", this.selectedMapCategory)
    } catch (e) {
      console.error(e);
    }

    this.fetchProducts();
  }

  /********************************   Ads **************************************/

  public ads = [];
  public adsLeft = [];

  private _loadAds() {
    return this.auth
      .getAllMapAds({
        filter: this.comicChatFilter,
      })
      .pipe(
        tap((data) => {
          this.ads = data.body.filter((ad) => ad.position == 'right');
          this.adsLeft = data.body.filter((ad) => ad.position == 'left');
        }),
      );
  }

  private _adsInterval;
  private _adsIntervalLeft;

  private _disposeAds() {
    if (this._adsInterval) {
      clearInterval(this._adsInterval);
    }
  }

  private _currentAdIndex = 0;
  public currentAdImage = '';
  private _currentAdIndexLeft = 0;
  public currentAdImageLeft = '';

  private _initAdsInterval() {
    this._loadAds().subscribe({
      next: () => {
        this.currentAdImage = '';
        this.currentAdImageLeft = '';
        this._currentAdIndex = 0;
        this._currentAdIndexLeft = 0;

        if (this._adsInterval) {
          clearInterval(this._adsInterval);
        }
        if (this._adsIntervalLeft) {
          clearInterval(this._adsIntervalLeft);
        }

        if (this.ads?.length) {
          // Show first ad immediately
          const currentAd = this.ads[this._currentAdIndex];
          this._playAdTransition('right', () => {
            if (currentAd.uploadedImage) {
              this.currentAdImage = this.imgUrl + currentAd.uploadedImage;
            } else if (currentAd.url) {
              this.currentAdImage = currentAd.url;
            }
          });

          this._adsInterval = setInterval(() => {
            this._currentAdIndex++;
            this._currentAdIndex %= this.ads.length;

            const currentAd = this.ads[this._currentAdIndex];

            this._playAdTransition('right', () => {
              if (currentAd.uploadedImage) {
                this.currentAdImage = this.imgUrl + currentAd.uploadedImage;
              } else if (currentAd.url) {
                this.currentAdImage = currentAd.url;
              }
            });
          }, 5000);
        }

        if (this.adsLeft?.length) {
          // Show first left ad immediately
          const currentAdLeft = this.adsLeft[this._currentAdIndexLeft];
          this._playAdTransition('left', () => {
            if (currentAdLeft.uploadedImage) {
              this.currentAdImageLeft =
                this.imgUrl + currentAdLeft.uploadedImage;
            } else if (currentAdLeft.url) {
              this.currentAdImageLeft = currentAdLeft.url;
            }
          });

          this._adsIntervalLeft = setInterval(() => {
            this._currentAdIndexLeft++;
            this._currentAdIndexLeft %= this.adsLeft.length;

            const currentAdLeft = this.adsLeft[this._currentAdIndexLeft];

            this._playAdTransition('left', () => {
              if (currentAdLeft.uploadedImage) {
                this.currentAdImageLeft =
                  this.imgUrl + currentAdLeft.uploadedImage;
              } else if (currentAdLeft.url) {
                this.currentAdImageLeft = currentAdLeft.url;
              }
            });
          }, 5000);
        }
      },
    });
  }

  private _playAdTransition(target: 'right' | 'left', cb: () => void): void {
    if (target === 'right') {
      this.adImageState = 'exiting';
    } else {
      this.adImageLeftState = 'exiting';
    }

    setTimeout(() => {
      cb();
      if (target === 'right') {
        this.adImageState = 'entering';
      } else {
        this.adImageLeftState = 'entering';
      }

      setTimeout(() => {
        if (target === 'right') {
          this.adImageState = 'visible';
        } else {
          this.adImageLeftState = 'visible';
        }
      }, this._adAnimationDelay);
    }, this._adAnimationDelay);
  }

  public deleteCurrentAd(position = 'right') {
    const ads = position == 'right' ? this.ads : this.adsLeft;
    const currentAdIndex =
      position == 'right' ? this._currentAdIndex : this._currentAdIndexLeft;
    if (ads?.length == 0) {
      return;
    }
    const adToBeDeleted = ads[currentAdIndex];

    this.local
      .confirmYesNo({
        title: 'Delete Ad',
        icon: 'warning',
        text: 'Are you sure you want to delete this ad',
      })
      .then((res) => {
        if (res.isConfirmed) {
          this.auth.deleteMapAd(adToBeDeleted.id).subscribe({
            next: () => {
              this.toastr.success('Ad Deleted');
              this._initAdsInterval();
            },
          });
        }
      });
  }

  public async openUploadAdImage(position = 'right') {
    if (!this.isAdmin) {
      return;
    }

    const modalRef = this.modalService.open(UploadEditedImageComponent, {
      size: 'md',
      centered: true,
    });
    // modalRef.shown.subscribe(() => this.initCropper())

    let topText = '';
    const user = this.local.getUser();

    if (user) {
      topText = this.commonService.getSubregionName(user.region);
    }
    modalRef.componentInstance.topText = topText;
    modalRef.result.then(async (res: EditedImageBatchResult) => {
      const images = res?.images ?? [];
      if (!images.length) {
        return;
      }

      let successCount = 0;
      let failedCount = 0;

      for (const image of images) {
        try {
          const converted = await this.commonService.convertWithWebCodecs(
            image.imageData,
          );
          await firstValueFrom(
            this.auth.createMapAd({
              image: converted,
              url: '',
              position,
              filter: this.comicChatFilter,
            }),
          );
          successCount++;
        } catch (error: any) {
          failedCount++;
          const message = error?.error?.message || 'Failed to create ad';
          this.toastr.error(message);
        }
      }

      if (successCount) {
        this._initAdsInterval();
        this.toastr.success(
          `${successCount} ad${successCount > 1 ? 's' : ''} created!`,
        );
      }

      if (failedCount && !successCount) {
        this.toastr.error('No ads were created.');
      }
    });
  }
  openEstimator() {
    this._updateUrlWithQueryParam('estimator', '1');
    this.modalRef = this.modalService.open(EstimatorModalComponent);

    const { componentInstance } = this.modalRef;

    componentInstance.selectedMapCategory = this.selectedMapCategory;
    componentInstance.currentSelectedTypes = this.currentSelectedTypes;
    componentInstance.viewProd.subscribe(prod =>{
      this.viewProduct(prod)
    })
  }
  openCust() {
    document.getElementById('customersBtn')?.click();
  }

  openShowBookingsModal() {
    // Update URL to include booking=1 parameter

    this._updateUrlWithQueryParam('booking', '1');

    this.modalRef = this.modalService.open(ShowBookingsComponent, {
      size: 'md',
      backdrop: 'static',
    });

    const componentInstance = this.modalRef
      .componentInstance as ShowBookingsComponent;
    componentInstance.selectedMapCategory = this.selectedMapCategory;
    componentInstance.isSelectSubCat = this.isSelectSubCat;
    componentInstance.currentSelectedTypes = this.currentSelectedTypes;
    componentInstance.mapCategories = this.mapCategories;
    componentInstance.locationCondition = this.getLocationCondition();
    componentInstance.filter = this.comicChatFilter;
    componentInstance.openEstimatorModal.subscribe(() => {
      this.openEstimator();
    });

    // Pass the updated booking questions and data
    componentInstance.currentCategoryBookingQuestions =
      this.currentCategoryBookingQuestions;
    componentInstance.currentCategoryTagList = this.currentCategoryTagList;
    componentInstance.currentCategoryBookingImageInfo =
      this.currentCategoryBookingImageInfo;

    componentInstance.productLocationClicked.subscribe((product) => {
      this.showProductLocationOnMap(product);
    });

    componentInstance.productViewClicked.subscribe((product) => {
      this.viewProduct(product);
    });

    this.modalRef.hidden.subscribe(() => {
      this.bookingResultProducts = [];
      this.currentBookingPage = 0;
      // Remove query param when modal closes

      this._updateUrlWithQueryParam('booking', null);
    });
  }

  openEditBookingContentModal(event: Event) {
    event.stopPropagation();
    this.modalRef = this.modalService.open(EditBookingContentComponent, {
      size: 'md',
      backdrop: 'static',
    });

    const componentInstance = this.modalRef
      .componentInstance as EditBookingContentComponent;
    componentInstance.title = this.bookingData.title;
    componentInstance.description = this.bookingData.description;
    componentInstance.icon = this.bookingData.icon;
    componentInstance.color = this.bookingData.color || 'primary';
    componentInstance.contentButtonMobileValue =
      this.bookingData.contentButtonMobile || false;
    componentInstance.filter = this.comicChatFilter;

    componentInstance.contentSaved.subscribe((content) => {
      // Handle the saved content here
      // You can update the title, icon, and description in your component
      console.log('Saved content:', content);
      // TODO: Update the actual content displayed in the book-with-kachiing element
    });
  }

  get filter() {
    if (this.currentSelectedTypes?.length) {
      return 'type';
    } else if (this.selectedMapCategory?.slug) {
      return 'sub-category';
    } else {
      return 'category';
    }
  }

  get filterId() {
    if (this.currentSelectedTypes?.length) {
      return this.currentSelectedTypes[0]?.id;
    } else if (this.selectedMapCategory?.slug) {
      return this.selectedMapCategory?.slug;
    } else {
      return this.selectedMapCategory?.id;
    }
  }

  //********************** Edit Category  ***************************************/
  public currentCategoryBookingImageInfo: any = {};
  openEditCategoryModal() {
    this.modalRef = this.modalService.open(EditCategoryComponent, {
      size: 'md',
    });
    const componentInstance = this.modalRef
      .componentInstance as EditCategoryComponent;

    componentInstance.subCategory = this.selectedMapCategory;
    componentInstance.categoryEditMode = this.selectedMapCategory?.slug;
    componentInstance.isSubCat = this.isSelectSubCat;
    if (this.currentSelectedTypes?.length) {
      componentInstance.currentType = this.currentSelectedTypes[0];
    }
    //this.categoryEditMode = this.subRegionSlug;
    //this.categoryName = this.subCategory?.name;
    componentInstance.categoryName =
      this.selectedMapCategory?.name ?? this.selectedMapCategory?.categoryName;

    try {
      componentInstance.subCategory.faqInfos = JSON.parse(
        this.selectedMapCategory.faqInfos,
      );
    } catch (e) {
      console.error(e);
    }
    //console.log(this.selectedMapCategory.faqInfos, 'faqInfos');
    componentInstance.currentBottomText = this.selectedMapCategory.bottomText; //  .currentBottomText = this.bottomText;

    componentInstance.categoryMeta = this.selectedMapCategory?.categoryMeta; //invalid json everytime!
    componentInstance.codeSchema = this.selectedMapCategory?.codeSchema;
    componentInstance.categoryImage = this.selectedMapCategory?.categoryImage;

    // componentInstance.attachedProductSlugFive =
    //   this.selectedMapCategory?.faqInfos?.attachedProductSlugFive;
    // componentInstance.attachedProductSlugFour =
    //   this.selectedMapCategory?.faqInfos?.attachedProductSlugFour;
    // componentInstance.attachedProductSlugThree =
    //   this.selectedMapCategory?.faqInfos?.attachedProductSlugThree;
    // componentInstance.attachedProductSlugTwo =
    //   this.selectedMapCategory?.faqInfos?.attachedProductSlugTwo;
    // componentInstance.attachedProductSlugOne =
    //   this.selectedMapCategory?.faqInfos?.attachedProductSlugOne;

    try {
      componentInstance.domMeta = Array.from(document.querySelectorAll('meta'))
        .map((meta) => {
          return `<meta name ='${meta.getAttribute('name') || null
            }'  property='${meta.getAttribute('property') || null}' 
          content='${meta.getAttribute('content') || null}'
          >`;
        })
        .join('\n');
      componentInstance.domSchema = Array.from(
        document.querySelectorAll('script[type="application/ld+json"]'),
      )
        .map((elem) => {
          return `<script type="application/ld+json">
               ${elem.textContent}
          </script>`;
        })
        .join('\n');
    } catch (e) {
      console.error(e);
      this.toastr.error(
        'Something went wrong while fetching schema and meta from DOM',
      );
    }
    this.modalRef.hidden.subscribe(() => {
      //refresh category data here
      this.commonService.refreshCategoryData();
      const temp = this.selectedMapCategory;
      this.selectedMapCategory = null;
      this.cdr.detectChanges();
      this.selectedMapCategory = temp; //refresh on ui
      this.cdr.detectChanges();
    });
  }

  public currentSelectedTypes = [];
  private buildQueryParams() {
    const rv = new URLSearchParams();

    if (this.hideCategory) {
      rv.append('hideCategory', '1');
    }
    if (this.searchText?.trim()) {
      rv.append('search', this.searchText?.trim());
    }

    return rv;
  }

  private setURLBasedOnSelectedTypesAndSettings() {
    //urls has type/cat/subcat slug
    //slug of these start with t-/c-/s- respectively
    //there are also settings such as hideCategory & booking & search

    let slug = '';
    const urlQueryParams = this.buildQueryParams().toString();

    if (this.currentSelectedTypes?.length) {
      slug = `t-${this.currentSelectedTypes[0].slug}`;
    } else if (this.isSelectSubCat && this.selectedMapCategory) {
      slug = `s-${this.selectedMapCategory.slug}`;
    } else if (this.selectedMapCategory) {
      slug = `c-${this.selectedMapCategory.slug}`;
    }
    if(this.viewMode == 'shop'){
      slug += '/shop'
    }

    this.location.replaceState(
      `/map${slug ? '/' + slug : ''}${urlQueryParams ? '?' + urlQueryParams : ''
      }`,
    );
  }
  public setCurrentType(types) {
    console.log('woooo', types);
    this.currentSelectedTypes = types;
    this.setURLBasedOnSelectedTypesAndSettings();

    if (types?.length > 0) {
      this.mainTitle = types[0]?.name;
      this.auth
        .fetchProductsBasedOnTypes({
          types: types.map((type) => type.id),
          page: 1,
          isSubType: false,

          ...this.getLocationCondition(),
        })
        .subscribe({
          next: (data: any) => {
            this._getBookingMoreInfos(
              this.currentSelectedTypes?.length
                ? this.currentSelectedTypes[0]
                : this.selectedMapCategory,
            );
            this.clearFilterSearch();

            this.productsList = this._sortProductsByInfo(data.data);
            this.googleMapsService.addProductDataToMap(
              this.productsList,
              'products',
            );
            this.googleMapsService.addUsersMarkerOnMap(false);

            this.cdr.detectChanges();
          },
        });
    } else {
      this.currentSelectedTypes = [];
      this.fetchProducts();
    }
    this.setupBookingData();
    this.fetchShopVariantCategories();
  }

  get comicChatFilter() {
    let filter = 'map';
    if (this.selectedMapCategory?.id) {
      filter += `-${this.selectedMapCategory?.id}`;
    }
    if (this.currentSelectedTypes?.length) {
      filter += `-${this.currentSelectedTypes
        .map((type) => type.id)
        .join('-')}`;
    }
    return filter;
  }

  /******************** Code related to asking questions  *************************/
  public viewOpenModelAddQuestion: boolean = false;
  public askQuestionText = '';
  public selectedImage: string | null = null;
  public selectedImageFile: File | null = null;

  public onImageSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        this.toastr.error('Please select a valid image file');
        return;
      }

      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        this.toastr.error('Image size should be less than 5MB');
        return;
      }

      this.selectedImageFile = file;

      // Create preview URL
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.selectedImage = e.target.result;
        this.cdr.detectChanges();
      };
      reader.readAsDataURL(file);
    }
  }

  public removeImage(event: Event): void {
    event.stopPropagation(); // Prevent triggering file input
    this.selectedImage = null;
    this.selectedImageFile = null;
    this.cdr.detectChanges();
  }

  public addQuestionToForumMap() {
    // Merge selected image into text as <img> element instead of uploading binary
    let textToSend = this.askQuestionText || '';
    if (this.selectedImage) {
      const imgTag = `<p><img src="${this.selectedImage}" alt="question image" /></p>`;
      textToSend = textToSend ? `${textToSend}\n${imgTag}` : imgTag;
    }

    const categoryId = this.isSelectSubCat
      ? this.selectedMapCategory?.categorieChildId
      : this.selectedMapCategory?.id;

    const payload = {
      categoryId: categoryId,
      text: textToSend,
      filter: this.comicChatFilter,
      filterId: '',
      filterForum: this.comicChatFilter,
    };

    this.auth
      .addForumMap(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.toastr.success('Question added');
          this.askQuestionText = '';
          this.selectedImage = null;
          this.selectedImageFile = null;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.toastr.error(err.error?.message || 'Something went wrong');
        },
      });
  }
  private checkEstimator() {
    const { id, isType } = this.getCurrentSelectedTypeAndId();
    this.auth.getBookingVariableSuperGroupsByCategory(id, isType).subscribe({
      next: (res) => {
        this.hasEstimator = res.body?.length;
      },
    });
  }

  public setupBookingData() {
    this.setupChat();
    // this.setupBgColor();
    this.setupHomepageColor();
    this.setupContactInfo();
    this._fetchAnsweredQuestions();
    this.checkEstimator();
  }
  public setupChat() {
    this.isChatAllowed =
      !!this.selectedMapCategory?.bookingMoreInfos?.allowChat;
    if (this.currentSelectedTypes?.length) {
      this.isChatAllowed =
        !!this.currentSelectedTypes[0]?.bookingMoreInfos?.allowChat;
    }
  }
  public setupBgColor() {
    this.commonService.mapCustomizationObserver
      .pipe(takeUntil(this.destroy$))
      .subscribe((customization) => {
        this.backgroundColor =
          customization.mapSideColor ??
          'var(--white)';
        this.mapHeaderColor =
          customization.mapHeaderColor ??
          'var(--primary)';
      });
  }

  public setupHomepageColor() {
    // Load customization data
    this.commonService.getCustomization();
    
    // Subscribe to customization updates
    this.commonService.customizationObserver
      .pipe(takeUntil(this.destroy$))
      .subscribe((customization: any) => {
        this.updateHomepageColor(customization);
      });
  }

  private updateHomepageColor(customization: any): void {
    if (customization && customization.homepageColor) {
      try {
        const homepageColor = typeof customization.homepageColor === 'string' 
          ? JSON.parse(customization.homepageColor) 
          : customization.homepageColor;
        
        if (homepageColor && homepageColor.type && homepageColor.colors) {
          let backgroundStyle = '';
          
          if (homepageColor.type === 'solid') {
            backgroundStyle = homepageColor.colors[0];
          } else {
            // Build gradient with percentages if available
            if (homepageColor.stops && homepageColor.stops.length === homepageColor.colors.length) {
              const gradientStops = homepageColor.colors.map((color: string, index: number) => 
                `${color} ${homepageColor.stops[index]}%`
              ).join(', ');
              backgroundStyle = `linear-gradient(135deg, ${gradientStops})`;
            } else {
              // Fallback to simple gradient without percentages
              const gradientColors = homepageColor.colors.join(', ');
              backgroundStyle = `linear-gradient(135deg, ${gradientColors})`;
            }
          }
          
          this.homepageColorStyle = { background: backgroundStyle };
        } else {
          // Use default gradient
          this.homepageColorStyle = {
            background: 'linear-gradient(135deg, #7318cd 0%, #9b1dff 40%, #6320ff 70%, #bc1aab 100%)'
          };
        }
      } catch (e) {
        console.error('Error parsing homepageColor:', e);
        // Use default gradient on error
        this.homepageColorStyle = {
          background: 'linear-gradient(135deg, #7318cd 0%, #9b1dff 40%, #6320ff 70%, #bc1aab 100%)'
        };
      }
    } else {
      // Use default gradient if no customization
      this.homepageColorStyle = {
        background: 'linear-gradient(135deg, #7318cd 0%, #9b1dff 40%, #6320ff 70%, #bc1aab 100%)'
      };
    }
    this.cdr.detectChanges();
  }

  private _getBookingMoreInfos(selectedCategory) {
    this.currentCategoryTagList =
      selectedCategory?.bookingMoreInfos?.tagChoices ?? [];
    this.currentCategoryBookingImageInfo = (
      selectedCategory?.bookingMoreInfos?.uploadedImages as any[]
    )?.at(0);

    if (!this.currentCategoryBookingImageInfo) {
      this.currentCategoryBookingImageInfo = {
        url: '',
        imageFile: null,
        caption: '',
        convertedFileUrl: null,
      };
    }
    //console.log('IMAGE INFO', this.currentCategoryBookingImageInfo);
    try {
      this.currentCategoryBookingQuestions = JSON.parse(
        selectedCategory.mapQuestions ?? '[]',
      );
    } catch (e) { }
  }

  timeoutBookingModal: any;
  private _checkAndOpenModalFromQueryParams(): void {
    if (!this.sharedService.isBrowser()) {
      return;
    }

    const url = new URL(window.location.href);
    const bookingParam = url.searchParams.get('booking');
    const storyParam = url.searchParams.get('story');
    const estimatorParam = url.searchParams.get('estimator');

    // Open booking modal if booking=1
    if (estimatorParam == '1') {
      this.timeoutBookingModal = setTimeout(() => {
        this.openEstimator();
      }, 500);
    } else if (bookingParam === '1') {
      // Wait a bit for the component to fully initialize
      this.timeoutBookingModal = setTimeout(() => {
        this.openShowBookingsModal();
      }, 500);
    }
    // Open story modal if story=1
    else if (storyParam === '1') {
      // Wait a bit for the component to fully initialize
      this.timeoutBookingModal = setTimeout(() => {
        this.openStore();
      }, 500);
    }
  }

  private _updateUrlWithQueryParam(key: string, value: string | null): void {
    if (!this.sharedService.isBrowser()) {
      return;
    }

    const url = new URL(window.location.href);

    if (value === null) {
      // Remove the query parameter
      url.searchParams.delete(key);
    } else {
      // Add or update the query parameter
      url.searchParams.set(key, value);
    }

    // Build the new URL preserving existing query params
    const newQueryString = url.searchParams.toString();
    const basePath = window.location.pathname;
    const newUrl = newQueryString ? basePath + '?' + newQueryString : basePath;
    this.location.replaceState(newUrl);
  }
  openShopSignoutPopup(modal) {
    this.modalService.dismissAll();
    this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'shop_signin_pop',
    });
    // this.router.navigateByUrl('/');
  }
  public logout(): void {
    //console.log('logging out');
    this.auth
      .logout_customer_marketplace({ id: this.appUserId })
      .subscribe((response: ApiResponse) => { });
    this.modalDismissAll();
    this.toastr.success('Sign out successfully.');
    this.memberNotificationService.clearNotification();
    this.local.logout();
    //this.local.fetchUser();
    //this.router.navigateByUrl('/');
    window.location.reload();
  }
  modalDismissAll() {
    this.modalService.dismissAll();
  }

  // Wizard component
  public isWizardVisisble = true;

  public openOptionalRecommModal() {
    const ref = this.modalService.open(RecommendationsFormComponent, {
      size: 'md',
    });

    ref.componentInstance.pollId = this.surveyData.poll.id;
    const subregion = this.commonService.subRegionLists.find(
      (sub) => sub.subRegionId == this.local.getUser()?.region,
    );
    ref.componentInstance.selectedRecommTypeIndex = 0;
    ref.componentInstance.selectedSubRegion = subregion;
    ref.componentInstance.onlyVisibleInfos = ['region', 'companyName', 'name'];
  }
  public closeWizardPermanently() {
    this.isWizardVisisble = false;
    this.surveyData.isOpen = false;
    this.cdr.detectChanges();
  }
  public setSurveyCat(cat) {
    this.surveyData.page = 2;
    this.selectedCat = cat;
    this.cdr.detectChanges();
  }
  public setSurveySubCat(subcat) {
    ///set tag here but also need a way to choose poll form
    // also filter same subregion
    this.surveyData.page = 3;
    this.surveyData.selectedSubCat = subcat;
    //console.log({ subcat });
    // console.log('showing poll');
    this.auth
      .poll_fetch({
        isAll: false,
        productId: null,
        fetchCategoryOnly: false,
        categoryId: subcat?.categorieChildId,
        subRegionId: this.local.getUser()?.region,
      })
      .subscribe({
        next: (data: any) => {
          //console.log('poll data', data);
          this.surveyData.poll = data.body.data[0];
          // console.log('poll=', this.surveyData.poll);
          if (!this.surveyData.poll) {
            this.surveyData.page = 4;
          }

          this.cdr.detectChanges();
        },
        error: console.error,
      });
  }
  public subcatsWithPoll = [];
  public pollSelectedProduct = null;
  public setPollSelected(productName) {
    this.pollSelectedProduct = { name: 'Loading...' };
    this.auth.getMemberShopProductByName(productName).subscribe({
      next: (data) => {
        this.pollSelectedProduct = data.body;
        this.cdr.detectChanges();
      },
    });
  }

  public storeAffordableData(ans) {
    this.auth.addAfforableScore(this.pollSelectedProduct?.id, ans).subscribe({
      next: () => {
        this.pollSelectedProduct = null;
        this.cdr.detectChanges();
      },
    });
  }
  public openPollForm() {
    this.auth
      .poll_fetch({ isAll: false, productId: null, fetchCategoryOnly: true })
      .subscribe({
        next: (data: any) => {
          this.subcatsWithPoll = data.body.data;
          if (this.subcatsWithPoll?.length == 0) {
            this.surveyData.page = -1; //go to thank you
            return;
          }
          this.surveyData.page = 2;
          this.cdr.detectChanges();
        },
        error: console.error,
      });
  }
  // public delightsCat = null
  public selectedCat = null;
  public categories = [];
  private _fetchSurveyInfos() {
    // this.delightsCat = this.commonService.subCategoryList.find(cat => cat.name?.toLowerCase()?.include('local delights'))
    this.commonService.categoryList.subscribe((response: any) => {
      this.categories = structuredClone(response);
      this.cdr.detectChanges();
    });
    // console.log('delight', this.delightsCat, )
    this.auth.getAssignedPointRewards().subscribe({
      next: (data) => {
        this.surveyData.recommPayAmmount =
          data.body.find((tple) => tple.action == 'POLL_REWARD')?.reward ?? 0;
        this.cdr.detectChanges();
      },
      error: console.log,
    });
  }
  public setComparableChoice(ans) {
    if (ans == 'Yes') {
      this.surveyData.askQualityQn = true;
      this.surveyData.poll.industryStandard = '';
    } else {
      this.surveyData = null;
    }
  }

  public surveyData = {
    isOpen: false,
    page: 0,
    selectedCat: '',
    poll: null,
    askQualityQn: false,
    recommPayAmmount: 0,
    selectedSubCat: null,
  };
  private _openSurvey({ page = 0, selectedSubCat = null, poll = {} } = {}) {
    this.surveyData.isOpen = true;
    this.surveyData.page = page;
    this.surveyData.selectedSubCat = selectedSubCat;
    this.surveyData.poll = poll;
    this.isWizardVisisble = true;
    this.cdr.detectChanges();
  }
  // public goToPoll(selectedCat){
  //   this.surveyData.page = 1;
  //   this.surveyData.selectedCat = selectedCat;
  //   console.log(selectedCat, this.delightsCat)
  //   if(selectedCat?.id == this.delightsCat.id){
  //     this.openPollForm()

  //   }else{
  //     console.log('hiding wizard')

  //     this.surveyData.isOpen = false;
  //     this.isWizardVisisble = false;

  //   }
  // }
  private get selectedTypeAndCategory() {
    let selectedType: 'CAT' | 'SUBCAT' | 'TYPE' = 'CAT';
    let selectedData = this.selectedMapCategory;

    if (this.currentSelectedTypes?.length) {
      selectedType = 'TYPE';
      selectedData = this.currentSelectedTypes[0];
    } else if (this.selectedMapCategory?.categorieChildId) {
      selectedType = 'SUBCAT';
    }

    return { selectedData, selectedType };
  }
  private setupContactInfo() {
    const { selectedData } = this.selectedTypeAndCategory;
    this.contactWhatsapp = selectedData?.bookingMoreInfos?.contactWhatsApp;

    //console.log("contact info", this.contactWhatsapp, {selectedData})
  }

  private _promptNickName(data) {
    Swal.fire({
      title: 'Missing Nickname',
      text: 'Please Enter A Profile Nick Name',
      icon: 'info',
      showCancelButton: false,
      confirmButtonColor: 'var(--primary)',
      input: 'text',
      //type: "input",
      //closeOnConfirm: false,
      // animation: "slide-from-top",
      inputPlaceholder: 'Write something',
      confirmButtonText: 'Done',
    }).then((res) => {
      if (!res.value) {
        this.toastr.error('Invalid value!');
        this._promptNickName(data);
        return;
      }
      const formData = new FormData();

      Object.keys(data).map((row) => {
        if (typeof data[row] === 'boolean') {
          formData.append(row, data[row] ? '1' : '0');
        } else {
          formData.append(row, data[row]);
        }
      });
      formData.delete('profileCharacterName');
      formData.delete('postalCode');
      formData.append('profileCharacterName', res.value);
      res.value;
      this.auth.updateProfileCharacterDetails(formData).subscribe({
        next: () => {
          this.toastr.success('Changed!');
          this._openSurvey();
        },
        error: (err) => {
          console.error(err);
          this._promptNickName(data);
          this.toastr.error(err.error.message);
        },
      });
    });
  }
  public surveyOpenEndenAnswer = '';
  public storeQualityAns(comparableAns) {
    this.auth
      .addOpenEndedAnswer({ pollId: this.surveyData?.poll?.id, comparableAns })
      .subscribe({
        next: () => {
          this.surveyData.poll.industryStandard = '';
          this.surveyData.askQualityQn = false;
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error(err);
          this.surveyData.poll.industryStandard = '';
        },
      });
  }
  public giveReward() {
    this.auth
      .givePollReward(this.surveyData?.poll?.id)
      .subscribe({ error: console.error });
  }
  public storeOpenEndedQn() {
    this.auth
      .addOpenEndedAnswer({
        pollId: this.surveyData?.poll?.id,
        answer: this.surveyOpenEndenAnswer,
      })
      .subscribe({
        next: () => {
          this.surveyData.poll.openEndedQuestion = '';
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error(err);
          this.surveyData.poll.openEndedQuestion = '';
          this.cdr.detectChanges();
        },
      });
  }
  public showProductExplainer = false;
  public mobileAds = [];
  private adChangeTimeout = null;
  public selectedMobileAd = null;
  public glowMobileAds = true;
  public giggleWiz = false;
  timeout1: any;
  timeout2: any;

  private getRandom(max) {
    let rnd = Math.random() * max;
    rnd = Math.floor(rnd);
    return rnd;
  }

  public showMobileAd() {
    const url = window.location.href;
    const isSeeingProductDetail =
      url.includes('?product=') || url.includes('/product/');

    if (isSeeingProductDetail || this.showProductExplainer) {
      //while product is being explained not mobile ad
      return;
    }

    if (this.mobileAds.length) {
      if (this.adChangeTimeout) {
        clearTimeout(this.adChangeTimeout);
        this.adChangeTimeout = null;
      }
      if (this.selectedMobileAd) {
        this.selectedMobileAd = null;
        return;
      }
      this.selectedMobileAd =
        this.mobileAds[this.getRandom(this.mobileAds.length)];

      this.adChangeTimeout = setTimeout(() => {
        this.selectedMobileAd = null;
      }, 3000);
      this.glowMobileAds = false;
      this.local.clearTimeout(this.timeout1);
      this.timeout1 = setTimeout(() => {
        this.glowMobileAds = true;
      }, 20_000); //glow will stop for 20 sec then return(only for ads)
    } else {
      this.giggleWiz = true;
      const audio = new Audio('../../../../assets/sounds/ouch.m4a');

      audio.play().catch(console.error);

      this.local.clearTimeout(this.timeout2);
      this.timeout2 = setTimeout(() => {
        this.giggleWiz = false;
      }, 2000);
    }
  }
  @ViewChild('menuOptions') menuOptions: MenuOptionsComponent;
  totalUnreadMessagesCount = 0;

  openMenuOptionsModal() {
    if (!this.isLogin) {
      this.openAdminWhatsApp()
      return;
    }
    this.menuOptions.openMenuOptionsModal();
  }
  public get areThereNewMessages(): boolean {
    return this.totalUnreadMessagesCount > 0;
  }
  marketplaceProfileSection: MarketplaceProfileComponent;

  openProfilePopup(tab) {
    this.marketplaceProfileSection?.tab
      ? (this.marketplaceProfileSection.tab = tab)
      : '';
    if (this.marketplaceProfileSection) {
      this.marketplaceProfileSection.showProfileMenu = true;
    }
    //problem scroll from here
    // if (isPlatformBrowser(this.platformId)) {
    //   document.body.style.overflow = 'hidden';
    // }
  }

  menuSliderLeft = false;

  //nav bottom
  openDiscuss() {
    document.getElementById('discuss-btn').click();
  }
  openMapCalculator() {
    this.swiper?.slideTo(2);
    setTimeout(() => {
      document.getElementById('map-calculator').scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }, 1000);
  }
  currentProductCategoryAvailableTypes: any = [];
  onTypesChanged(types: any[]) {
    console.log('Types received from child:', types);
    this.currentProductCategoryAvailableTypes = types;
  }

  get popUpImage() {
    return this.commonService.getPopupImageByFilterAndType(
      this.comicChatFilter,
      'sub-category-header',
    );
  }
  carouselOptions: any = {
    slidesPerView: 5,
    spaceBetween: 10,
    // breakpoints: {
    //   0: {
    //     slidesPerView: 3,
    //   },
    //   1024: {
    //     slidesPerView: 4,
    //   },
    //   1200: {
    //     slidesPerView: 7,
    //   },
    // },
  };

  dropdownOpen = false;

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectType(type: any) {
    if (type) {
      this.setCurrentType([type]);
    } else {
      this.setCurrentType(null);
    }
    // this.dropdownOpen = false;
  }
}
